<span *ngIf="header" class="field-header">{{ header }}</span>
<mat-form-field style="width: 100%" [ngClass]="header ? 'mt-2' : ''" [appearance]="appearance">
    <mat-label>{{ label }}</mat-label>
    <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
        <input matStartDate formControlName="start" (dateChange)="onDateChange($event)" placeholder="Start" />
        <input matEndDate formControlName="end" placeholder="End" (dateChange)="onDateChange($event)" />
    </mat-date-range-input>
    <!-- <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint> -->
    <mat-datepicker-toggle [disableRipple]="false" *ngIf="useAsFilter && !form.get(name)?.value" matIconSuffix
        [for]="picker" class="calendar-toggle">
        <mat-icon matDatepickerToggleIcon color="primary">calendar_today</mat-icon>
    </mat-datepicker-toggle>
    <mat-icon *ngIf="useAsFilter && form.get(name)?.value" matSuffix class="clear-filter-icon"
        (click)="clearFilter($event)">clear</mat-icon>
    <mat-date-range-picker #picker></mat-date-range-picker>
</mat-form-field>